/**
 * @generated SignedSource<<60399e0b4ab3719dfbb3abdc8dfc3374>>
 * @relayHash ab9a62ac2c1201531243fd5b09871f1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 05f5acde90f3c3e6d582e71577ba5915511132fe247d4870401deff1969cc803

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type SettingsMenuItemInput = {
  menuId: string;
  visible: boolean;
};
export type useSetNavCustomizationDataMutation$variables = {
  entityAri: string;
  ownerAri: string;
  sidebar?: ReadonlyArray<SettingsMenuItemInput | null | undefined> | null | undefined;
};
export type useSetNavCustomizationDataMutation$data = {
  readonly settings_updateNavigationCustomisation: {
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null | undefined;
        readonly visible: boolean | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useSetNavCustomizationDataMutation = {
  response: useSetNavCustomizationDataMutation$data;
  variables: useSetNavCustomizationDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ownerAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sidebar"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityAri",
        "variableName": "entityAri"
      },
      {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
      },
      {
        "kind": "Variable",
        "name": "sidebar",
        "variableName": "sidebar"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "concreteType": "SettingsMenuItemConnection",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsMenuItem",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "menuId"
        },
        {
          "kind": "ScalarField",
          "name": "visible"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSetNavCustomizationDataMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSetNavCustomizationDataMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "05f5acde90f3c3e6d582e71577ba5915511132fe247d4870401deff1969cc803",
    "metadata": {},
    "name": "useSetNavCustomizationDataMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d95cd1ea527e6e0c51412ce3da8dbd12";

export default node;
